var map = {
	"./redblack_en.png": "2yQ0",
	"./redblack_th.png": "ndnu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Q+fF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/redblack_.*\.png$
// module id = Q+fF
// module chunks = 1